import { ProductListQuery as SourceProductListQuery } from 'SourceQuery/ProductList.query';
import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/ProductList/Query */
export class ProductListQuery extends SourceProductListQuery {
    _getReservationPriceField() {
        return new Field('reservation_price')
            .addField('currency')
            .addField('value');
    }

    _getTransportationPriceField() {
        return new Field('transportation_price')
            .addField('currency')
            .addField('value');
    }

    _getRegistrationPriceField() {
        return new Field('registration_price')
            .addField('currency')
            .addField('value');
    }

    _getMinimalPriceFields() {
        return [
            ...super._getMinimalPriceFields(),
            this._getReservationPriceField(),
            this._getTransportationPriceField(),
            this._getRegistrationPriceField()
        ];
    }

    _getMaximalPriceFields() {
        return [
            ...super._getMaximalPriceFields(),
            this._getTransportationPriceField(),
            this._getRegistrationPriceField()
        ];
    }

    _getCartProductInterfaceFields() {
        return [
            ...super._getCartProductInterfaceFields(),
            this._getProductSmallField()
        ];
    }
}

export default new ProductListQuery();
